var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreadCrumbsArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0.15625 0.166016)",
    d: "M13.814569 15.530196C14.467403 16.156601 15.52305 16.156601 16.16894 15.530196L29.510374 2.7355268C30.163208 2.1091211 30.163208 1.0962099 29.510374 0.47646815C28.85754 -0.14327364 27.801893 -0.14993753 27.156004 0.47646815L15.002172 12.138276L2.8413956 0.46980426C2.1885612 -0.15660141 1.1329142 -0.15660141 0.48702487 0.46980426C-0.15886445 1.0962099 -0.1658095 2.1091211 0.48702487 2.728863L13.814569 15.530196Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadCrumbsArrow);
export default __webpack_public_path__ + "static/media/bread-crumbs-arrow.6788e1c2c2b892368f00fd03397fff65.svg";
export { ForwardRef as ReactComponent };